module.exports = __webpack_public_path__ + "img/catalogues-w.svg";